import React, { createContext, useState } from "react";

const CompaniesContext = createContext();

const CompaniesProvider = ({ children }) => {
  const orgTypes = [
    { value: "All", text: "All" },
    { value: "Client", text: "Client/Super Client" },
    { value: "Vendor", text: "Vendor" },
    { value: "Admin", text: "Admin" },
  ];

  const [resetCompanies, setRefreshCompanylist] = useState(false);
  const [sortOrder, setSortOrder] = useState("asc");
  const [lastSavedSelections, setFilterSelections] = useState({
    clientIds: [],
    superClientIds: [],
    adminIds: [],
    vendorIds: "",
    companyStatusActive: false,
    companyStatusInactive: false,
  });

  const deleteCompany = (companyId) => {
    setRefreshCompanylist(!resetCompanies);
  };

  return (
    <CompaniesContext.Provider
      value={{
        resetCompanies,
        setRefreshCompanylist,
        deleteCompany,
        setFilterSelections,
        lastSavedSelections,
        sortOrder,
        setSortOrder,
        orgTypes,
      }}
    >
      {children}
    </CompaniesContext.Provider>
  );
};

export { CompaniesContext, CompaniesProvider };
